module.exports = __webpack_public_path__ + "3db3dbf54be8354c0116c18d6507a9a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-fairyland.png
// module id = 2962
// module chunks = 0